import { render, staticRenderFns } from "./ComplianceListComponent.vue?vue&type=template&id=e5f25a96&"
import script from "./ComplianceListComponent.vue?vue&type=script&lang=js&"
export * from "./ComplianceListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports